import axios from "../instance";

export default {
    getAll: (warehouseId) => { // return axios.api.get(`/customer?warehouseId=${warehouseId}`).then((response) => response.data);
        return axios.api.get(`/sectors`).then((response) => response.data);
    },
    getOne: (id) => {
        return axios.api.get(`/sectors/${id}`).then((response) => response.data);
    },
    search: (body) => {
        return axios.api.post("/sectors/search", body).then((response) => response.data);
    },
    create: (body) => {
        return axios.api.post("/sectors", body).then((response) => response.data);
    },
    update: (id, body) => {
        return axios.api.put(`/sectors/${id}`, body).then((response) => response.data);
    },
    delete: (id) => {
        return axios.api.delete(`/sectors/${id}`).then((response) => response.data);
    }
};
